import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { SvgIconProps } from '@mui/material';

type CustomTooltipProps = {
  title: React.ReactNode;
  icon: React.ReactElement<SvgIconProps>;
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({ title, icon }) => {
  return (
    <Tooltip title={title}>
      <IconButton>{icon} </IconButton>
    </Tooltip>
  );
};

export default CustomTooltip;
